export const maybe = (defaultValue) => (value) => value || defaultValue;
